// extracted by mini-css-extract-plugin
export default {"editForm":"styles_editForm__spdXO","title":"styles_title__sg+1G","info":"styles_info__0c27I","editIcon":"styles_editIcon__AgZSj","editFormInfo":"styles_editFormInfo__upyC8"};